<template>
    <div class="real-name-authentication-box">
        
        <!-- 认证后 -->
        <div v-if="userProfile.kycStatus === 1||userProfile.kycStatus === 2||userProfile.kycStatus === 3" class="real-name-authentication-after">
            <div class="real-name-authentication-after-tips">
                <img class="real-name-authentication-has-done-icon" src="/images/home/my_center_has_done_icon.png"
                    alt="实名认证">
                <p class="real-name-authentication-has-done-text">您已完成实名认证！</p>
            </div>
            <ul>
                <li>
                    <p class="input-real-name-or-identity-car-title">姓名：</p>
                    <p class="input-real-name-or-identity-car-text">{{ realNameAuthInfo.realName }}</p>
                </li>
                <li>
                    <p class="input-real-name-or-identity-car-title">身份证号码：</p>
                    <p class="input-real-name-or-identity-car-text">{{ realNameAuthInfo.identityCard }}</p>
                </li>
            </ul>
        </div>
        <!-- 认证前 -->
        <div v-else class="real-name-authentication-before">
            <div class="real-name-authentication-tips">
                <ul>
                    <li>
                        <img class="real-name-authentication-not-done-icon"
                            src="/images/home/my_center_not_done_icon.png" alt="实名认证">
                        <p class="real-name-authentication-not-done-text">实名信息认证后不可更改，请本人认真填写。</p>
                    </li>
                    <li>
                        <img class="real-name-authentication-not-done-icon"
                            src="/images/home/my_center_not_done_icon.png" alt="实名认证">
                        <p class="real-name-authentication-not-done-text">后续涉及人脸、包赔等，如果与实名信息不匹配，则无法认证通过。</p>
                    </li>
                    <li>
                        <img class="real-name-authentication-not-done-icon"
                            src="/images/home/my_center_not_done_icon.png" alt="实名认证">
                        <p class="real-name-authentication-not-done-text">根据国家规定，未成年人禁止交易。注册手机号、姓名、身份证号必须与本人信息一致。</p>
                    </li>
                </ul>
            </div>
            <div class="real-name-authentication-input-box">
                <ul>
                    <li>
                        <p class="input-real-name-or-identity-car-icon">*</p>
                        <p class="input-real-name-or-identity-car-title">姓名：</p>
                        <input class="input-real-name-or-identity-car-text" v-model="realNameAuth.realName" type="text"
                            maxlength="24" placeholder="请输入姓名">
                    </li>
                    <li>
                        <p class="input-real-name-or-identity-car-icon">*</p>
                        <p class="input-real-name-or-identity-car-title">身份证号码：</p>
                        <input class="input-real-name-or-identity-car-text" v-model="realNameAuth.identityCard" type="text"
                            maxlength="18" placeholder="请输入身份证">
                    </li>
                </ul>
            </div>
            <div class="real-name-authentication-commit-btn-box" @click="clickRealNameAuthenticationBtnHandler()">
                <p class="real-name-authentication-commit-btn-text">提交</p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState,mapMutations } from 'vuex';
import { realNameAuthentication } from '@/services/myCenter/index.js';
import {getRealNameAuthInfo} from "@/services/user/index.js";
export default {
    name: "MyAccountSettingRealNameAuthentication",
    data() {
        return {
            realNameAuth:{
                realName: '',
                identityCard: ''
            }
        }
    },
    methods: {
        ...mapMutations('user',['setUserProfileForKycStatus','setRealNameAuthInfo']),
        //点击实名认证操作
        async clickRealNameAuthenticationBtnHandler() {
            if (this.realNameAuth.realName.trim().length < 1 || this.realNameAuth.identityCard.trim().length < 1) {
                this.$message.warning('请填写实名认证信息')
                return;
            }
            if(!this.validateIdCard(this.realNameAuth.identityCard)){
                this.$message.warning('请填写正确的身份证号信息')
                return;
            }
            //console.log('通过===');
            try{
                const {data} = await realNameAuthentication(this.realNameAuth);
                //console.log('RealNameAuthentication===');
                //console.log(data);
                if(data.code==21){ 
                    // this.$message.success('认证成功');
                    this.$confirm('认证成功','提示',{
                        showConfirmButton:true,
                        showCancelButton:false,
                        center:true
                    }).then(()=>{
                        //修改缓存中的kycStatus状态
                        this.setUserProfileForKycStatus(1);
                        //加载实名认证信息
                        this.loadRealNameAuthInfo();
                    })
                }else{
                    this.$confirm(data.message,'提示',{
                        showConfirmButton:true,
                        showCancelButton:false,
                        center:true
                    })
                }
            }catch(err){}

        },
        //验证身份证信息是否合法
        validateIdCard(idCard) {
            // 身份证号码正则表达式
            var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
            return reg.test(idCard);
        },
        //加载实名认证信息
        async loadRealNameAuthInfo(){
            try{
                const {data} = await getRealNameAuthInfo();
                if(data.code==200){
                    this.setRealNameAuthInfo(data.data);
                }
            }catch(err){}
        }
    },
    computed: {
        ...mapState({
            userProfile: state => state.user.userProfile,
            realNameAuthInfo: state=>state.user.realNameAuthInfo
        }),
    },
    mounted(){
        //加载实名认证信息
        if(this.userProfile.kycStatus==1||this.userProfile.kycStatus==2||this.userProfile.kycStatus==3){
            this.loadRealNameAuthInfo();
        }
    }
}
</script>

<style lang="less" scoped>
.real-name-authentication-box {
    background: #FFFFFF;
    width: 1200px;
    height: 363px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .real-name-authentication-before {
        width: 1200px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .real-name-authentication-tips {
            width: 1200px;
            display: flex;
            flex-direction: column;
            align-items: center;

            ul {
                list-style-type: none;
                padding: 0px;
                display: flex;
                flex-direction: column;
                align-items: flex-start;

                li {
                    list-style: none;
                    padding: 0px 14px;
                    height: 36px;
                    border-radius: 4px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: default;

                    .real-name-authentication-not-done-icon {
                        width: 12px;
                        height: 12px;
                    }

                    .real-name-authentication-not-done-text {
                        margin-left: 10px;
                        height: 16px;
                        font-family: MicrosoftYaHei;
                        font-size: 12px;
                        color: #F02233;
                        line-height: 16px;
                        text-align: left;
                        font-style: normal;
                    }
                }
            }
        }

        .real-name-authentication-input-box {
            width: 1200px;

            ul {
                margin-top: 30px;
                list-style-type: none;
                padding: 0px;
                display: flex;
                flex-direction: column;
                align-items: center;

                li {
                    width: 530px;
                    height: 60px;
                    list-style: none;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    background-color: #FFFFFF;

                    .input-real-name-or-identity-car-icon {
                        font-size: 16px;
                        color: #F02233;
                        margin-right: 3px;
                    }

                    .input-real-name-or-identity-car-title {
                        font-family: MicrosoftYaHei;
                        font-size: 16px;
                        color: #555555;
                        text-align: left;
                        font-style: normal;
                    }

                    .input-real-name-or-identity-car-text {
                        width: 420px;
                        height: 46px;
                        background: #FFFFFF;
                        border-radius: 8px;
                        border: 1px solid #F0F0F0;
                        outline: none;
                        padding-left: 14px;

                        &::placeholder {
                            font-family: MicrosoftYaHei;
                            font-size: 14px;
                            color: #CCCCCC;
                            text-align: left;
                            font-style: normal;
                        }
                    }
                }
            }
        }

        .real-name-authentication-commit-btn-box {
            margin-top: 30px;
            width: 200px;
            height: 46px;
            background: #F02233;
            border-radius: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: default;

            .real-name-authentication-commit-btn-text {
                height: 14px;
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 14px;
                text-align: right;
                font-style: normal;
            }
        }
    }

    .real-name-authentication-after {
        width: 1200px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .real-name-authentication-after-tips {
            display: flex;
            width: 150px;
            height: 36px;
            background: #ECFFF5;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: default;

            .real-name-authentication-has-done-icon {
                width: 12px;
                height: 12px;
            }

            .real-name-authentication-has-done-text {
                margin-left: 10px;
                height: 16px;
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #2CA767;
                line-height: 16px;
                text-align: left;
                font-style: normal;
            }
        }

        ul {
            list-style-type: none;
            padding: 0px;
            width: 320px;
            height: 120px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;

            li {
                margin-top: 20px;
                list-style: none;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: #FFFFFF;

                .input-real-name-or-identity-car-title {
                    font-family: MicrosoftYaHei;
                    font-size: 16px;
                    color: #555555;
                    text-align: left;
                    font-style: normal;
                }

                .input-real-name-or-identity-car-text {
                    // width: 190px;
                    font-family: MicrosoftYaHei;
                    font-size: 16px;
                    color: #555555;
                    text-align: left;
                    font-style: normal;
                }
            }
        }
    }
}
</style>